<template>
	<div class="flex flex-col lg:flex-row">
		<div class="flex w-full items-center lg:w-1/2 lg:gap-x-20">
			<div>
				<h2>What is an EV car subscription?</h2>
				<div class="space-y-5 text-lg text-gray-575">
					<p>
						Forget about long term commitments, an electric car
						subscription takes all the costs of traditional car
						ownership and rolls it up into a simple, convenient
						weekly subscription.
					</p>
					<p>
						Stamp duties and taxes, depreciation, registration,
						insurance, roadside assistance, servicing, maintenance
						and tyres are all included in the weekly subscription
						fee.
					</p>
					<p>
						You can subscribe to an electric vehicle for as little
						or as long as you like. You can stop or swap which just
						2 weeks notice. And if you love it? You can buy or
						finance your subscription car with carbar.
					</p>
					<p>
						Take the hassle, stress and uncertainty out of buying an
						electric car. Subscribe to a range of quality electric
						cars online today!
					</p>
				</div>
				<DoubleCta :is-stacked="false" class="mt-8">
					<template #primary>
						<CarbarLink
							:href="'/cars/subscribe/electric'"
							:underline="false"
						>
							<CarbarButton>
								Search and subscribe electric cars online
							</CarbarButton>
						</CarbarLink>
					</template>
					<template #secondary>
						<CarbarLink
							:font-size="'text-base'"
							:href="'/car-subscription'"
						>
							<CarbarButton :is-outline="true">
								Learn more about car subscription?
							</CarbarButton>
						</CarbarLink>
					</template>
				</DoubleCta>
			</div>
		</div>

		<div class="flex w-full items-center lg:w-1/2">
			<SimilarVehicles
				:show-header="false"
				:is-stacked="true"
				:breakpoints="null"
				:carousel-width="`w-full md:w-8/12 lg:w-9/12`"
				:filters="{ fuelTypes: 'electric' }"
				:show-slide-arrows="false"
				:show-more-threshold-limit="3"
			>
				<template #heading>
					Featured electric cars available for car subscription
				</template>
			</SimilarVehicles>
		</div>
	</div>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import DoubleCta from '@/components/buttons/DoubleCta.vue'
import SimilarVehicles from '@/components/vehicle-details/SimilarVehicles.vue'
</script>
